export default __webpack_public_path__ + "static/media/hub_logo_2025.ad4aae74.png";